import { Ruler, MessageSquare, FileText, Send } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/components/Bits";

export default function Dimensionamento() {
  const { openQuote } = useSite();
  const steps = [
    { icon: Send, t: "1. Envie sua aplicação", d: "Conte o processo, capacidade, temperatura e restrições." },
    { icon: Ruler, t: "2. Dimensionamos", d: "Nossa engenharia calcula a solução ideal para o seu caso." },
    { icon: FileText, t: "3. Proposta técnica", d: "Você recebe especificação e orçamento sob encomenda." },
    { icon: MessageSquare, t: "4. Acompanhamento", d: "Falamos por WhatsApp em cada etapa até a entrega." },
  ];
  return (
    <div>
      <PageHero eyebrow="Dimensionamento" title="Não sabe qual capacidade precisa? Nós calculamos para você."
        subtitle="Dimensionamento gratuito e sem compromisso. Envie os dados da sua aplicação e receba a solução técnica ideal."
        image="https://images.unsplash.com/photo-1581092163144-b7ae3c00adbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600">
        <div className="mt-9">
          <Button data-testid="dimension-start-button" onClick={() => openQuote({ source: "dimensionamento" })}
            className="rounded-none bg-[#FF5500] px-8 py-6 text-base font-bold hover:bg-[#CC4400]">Iniciar Dimensionamento</Button>
        </div>
      </PageHero>
      <div className="mx-auto max-w-[1400px] px-4 py-20 lg:px-8">
        <div className="grid grid-cols-1 gap-px border border-[#27272A] bg-[#27272A] md:grid-cols-4">
          {steps.map((s) => (
            <div key={s.t} className="bg-[#0A0A0B] p-8">
              <s.icon className="h-8 w-8 text-[#FF5500]" />
              <h3 className="font-heading mt-4 text-lg font-bold text-white">{s.t}</h3>
              <p className="mt-2 text-sm text-[#A1A1AA]">{s.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 border border-[#27272A] bg-[#151618] p-8">
          <p className="text-sm text-[#A1A1AA]">
            <span className="font-bold text-white">Importante:</span> capacidades, faixas e especificações são confirmadas
            somente após a análise de engenharia. Nenhum dado técnico é assumido sem validação.
          </p>
        </div>
      </div>
    </div>
  );
}
